// extracted by mini-css-extract-plugin
export default {"top":"detail_top__aUDXQ","titl":"detail_titl__0K3uV","nav":"detail_nav__6FTkP","con":"detail_con__taTHe"};